export const getAcceptAttribute = acceptedFormats => acceptedFormats.map(format => format.extension).join(',')

export const isAcceptedFormat = (file, acceptedFormats) => {
  const fileName = file.name.toLowerCase()

  return acceptedFormats.some(format => file.type === format.mimeType || fileName.endsWith(format.extension))
}
